import { FunctionComponent, Suspense, useEffect } from "react";

import { LoadingLogo } from "~/components/_deprecated/loading/loading-logo";
import { useI18n } from "~/hooks/use-i18n";

import { Flex } from "../components/_deprecated/primitives";

export function WaitingComponent(Comp: FunctionComponent) {
  // eslint-disable-next-line react/display-name
  return (props: Record<string, unknown> | null) => (
    <Suspense fallback={<LoadingPage />}>
      <Comp {...props} />
    </Suspense>
  );
}

export const LoadingPage = () => {
  const { t } = useI18n();
  useEffect(() => {
    if (t) {
      document.title = t("loading");
    }
  }, [t]);
  return (
    <Flex width="100%" height="100vh" alignItems="center" justifyContent="center">
      <LoadingLogo width="60" />
    </Flex>
  );
};
